/**
 * campaign-leads — Campaign by Leads (Basic). Same pipeline graph and status
 * filter as the companies template, but the directory also shows each lead's
 * name and role position: "who is moving" inside each account.
 */
import { CAMPAIGN_REVISION, validateCampaignReport, translationTexts, validateTranslations, type CampaignReport, type Translations } from '../../schema/campaign';
import { renderCampaignLeadsReport } from './render';

export const conf = {
  id: 'campaign-leads',
  name: 'Campaign by Leads (Basic)',
  description: 'Pipeline status and the lead directory — name, role and company.',
  revision: CAMPAIGN_REVISION,
  sourceKinds: ['campaign'] as const,
  pdfBucket: 'campaign-report-exports' as const,
  sectionConfig: false,
  i18n: 'dictionary' as const,
};

export const reportTemplate = {
  conf,
  validate: validateCampaignReport,
  translationTexts: (d: CampaignReport): Translations => translationTexts(d),
  validateTranslations: (d: CampaignReport, t: unknown) => validateTranslations(d, t),
  render: renderCampaignLeadsReport,
};
